module.exports = __webpack_public_path__ + "static/media/main-weapon-2.bd9ee4bc.png";